import React, { ReactNode, memo } from 'react'
import DeleteIcon from 'transfix-icons/build/DeleteIcon'
import EditIcon from 'transfix-icons/build/EditIcon'
import EllipsisIcon from 'transfix-icons/build/EllipsisIcon'
import IconButton from 'transfix-ui/components/IconButton'
import {
  OverflowMenu,
  IOverflowMenuProps,
  useOverflowToggle,
} from 'transfix-ui/components/OverflowMenu'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { brandColors } from 'transfix-ui/theme'
import { TEST_IDS } from '../constants'

const useCarrierOptionCardOverflowMenuStyles = makeStyles(theme => ({
  icon: {
    color: brandColors.skyBlue6,
  },
  menu: {
    marginLeft: 'auto',
    '& .menuOption': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
  },
}))

interface IMenuOptionProps {
  title: string
  icon?: ReactNode
}

const MenuOption = memo<IMenuOptionProps>(({ icon, title }) => {
  return (
    <div className='menuOption'>
      {icon && <>{icon}</>}
      <div>{title}</div>
    </div>
  )
})

export interface ICounterOfferCardOverflowMenuProps {
  /**
   * @default false
   */
  disabled?: boolean
  onDeleteClick: () => void
  onEditClick: () => void
}

const CounterOfferCardOverflowMenu = memo<ICounterOfferCardOverflowMenuProps>(
  ({ disabled, onDeleteClick, onEditClick }) => {
    const classes = useCarrierOptionCardOverflowMenuStyles()
    const { clickOverflowTrigger, expanded, setExpanded } = useOverflowToggle()

    const options: IOverflowMenuProps['options'] = [
      {
        itemComponent: <MenuOption title='Edit' icon={<EditIcon size='large' />} />,
        label: 'edit',
        action: onEditClick,
      },
      {
        itemComponent: <MenuOption title='Delete' icon={<DeleteIcon size='large' />} />,
        label: 'delete',
        action: onDeleteClick,
      },
    ]

    return (
      <>
        <OverflowMenu
          className={classes.menu}
          dataTest={TEST_IDS.counterOfferOverflowMenu}
          dropdownId='counter-offer-id'
          expanded={expanded}
          onExpanded={setExpanded}
          options={options}
          trigger={
            <IconButton
              className={classes.icon}
              data-test={TEST_IDS.counterOfferOverflowMenu}
              disabled={disabled}
              Icon={EllipsisIcon}
              label='menu'
              onClick={clickOverflowTrigger}
              size='large'
            />
          }
        />
      </>
    )
  }
)

export default CounterOfferCardOverflowMenu
